<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="900">
    <template #title>Allocation Use Details</template>
    <v-data-table :items="items" :headers="headers" :loading="$apollo.loading">
      <template v-slot:item.date="{ item }">
        {{ item.date | formatDate }}
      </template>
      <template v-slot:item.itineraryReference="{ item }">
        <reference-label
          v-model="item.itineraryReference"
          :itinerary-id="item.itinerary.id"
        ></reference-label>
      </template>
    </v-data-table>
    <div v-if="debug">
      <code>{{ value }}</code>
      <code>{{ itineraryHistories }}</code>
    </div>
  </basic-dialog>
</template>

<script>
import gql from "graphql-tag";
import BasicDialog from "../../shared/BasicDialog";
import { removeGQLTypename } from "../../../../helpers";
import ReferenceLabel from "../../shared/labels/ReferenceLabel.vue";
const ALLOC_USAGE = gql`
  query allocationsUsage($filter: HistoryFilterType) {
    itineraryHistories(first: 1000, filter: $filter) {
      totalCount
      edges {
        node {
          id
          date
          serviceName
          qty
          adults
          children
          itinerary {
            id
            agentName
            clientName
          }
          itineraryReference
          allocation {
            taken
            maxTotal
            type
          }
        }
      }
    }
  }
`;

const setCorrectTakenForAlloc = (item) => {
  if (item.allocation.type == "pax") {
    item.qty = Number(item.adults) + Number(item.children);
  }
  return item;
};
export default {
  name: "allocation-usage-dialog",

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => null,
    },
  },

  components: {
    BasicDialog,
    ReferenceLabel,
  },

  data() {
    return {
      debug: false,
      headers: [
        {
          text: "Date",
          value: "date",
          name: "date",
        },
        {
          text: "Service",
          value: "serviceName",
          name: "serviceName",
        },
        {
          text: "Agent",
          value: "itinerary.agentName",
          name: "itinerary.agentName",
        },
        {
          text: "Itinerary Ref",
          value: "itineraryReference",
          name: "itineraryReference",
        },
        {
          text: "Used",
          value: "qty",
          name: "qty",
        },
      ],
    };
  },

  computed: {
    items() {
      return this.itineraryHistories && this.itineraryHistories.edges
        ? this.itineraryHistories.edges
            .map(removeGQLTypename)
            .map(setCorrectTakenForAlloc)
        : [];
    },
  },

  apollo: {
    itineraryHistories: {
      query: ALLOC_USAGE,
      variables() {
        return {
          filter: {
            date_from_eq: this.value.date,
            allocation_eq: this.value.uid,
            service_id: this.value.service.id,
          },
        };
      },
      skip() {
        return !this.value && !this.show;
      },
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/suppliers/allocations/AllocationUsageDetailsDialog.vue